/** GraphFrame registration: parser. */
import { nodeRegistry } from '../../../../core/NodeRegistry';
import { parseGraphFrame } from './parser';
const graphFrameRegistration = {
    typeName: 'GraphFrame',
    parser: parseGraphFrame,
};
nodeRegistry.register(graphFrameRegistration);
export * from './parser';
export * from './types';
//# sourceMappingURL=index.js.map